import './ComplianceCategory.scss';
import { ComplianceCategories } from '@ui/icons';
import { ComplianceCategory } from '@sonar-software/sonar-core';
import { FilterComponent } from './FilterComponent';
import { getDirectParent } from '@lib/popups';
import { aggregateComplianceCategories, getFilterId, splitComplianceCategories } from '@ui/table-modifier/@arch/lib';
import { COPY_SPECIFIC, PLACEHOLDERS_COPY } from '@sonar-software/sonar-ts-constants';
import { OptionFilter } from '@periscopes/general/filters';
import React, { useMemo } from 'react';
const complianceCategories = Object.entries(ComplianceCategory).filter(([, id]) => typeof id === 'number');
function geLabelOverride(value) {
    if (value === ComplianceCategory.Any) {
        return COPY_SPECIFIC.ANY_COMPLIANCE_CATEGORY;
    }
    if (value === ComplianceCategory.None) {
        return COPY_SPECIFIC.NO_COMPLIANCE_CATEGORIES;
    }
    return null;
}
const options = complianceCategories.map(([label, value]) => {
    var _a;
    return ({
        label: (_a = geLabelOverride(value)) !== null && _a !== void 0 ? _a : label,
        value
    });
});
const transformSelection = (selected, previousSelection) => {
    if (!selected.length) {
        return undefined;
    }
    if (selected.includes(ComplianceCategory.None) && !previousSelection.includes(ComplianceCategory.None)) {
        return [ComplianceCategory.None];
    }
    else if (selected.includes(ComplianceCategory.Any) && !previousSelection.includes(ComplianceCategory.Any)) {
        return [ComplianceCategory.Any];
    }
    return selected.filter((categoryId) => categoryId !== ComplianceCategory.None && categoryId !== ComplianceCategory.Any);
};
export const ComplianceCategoryFilter = (props) => {
    const { format, id, label, onChange, value } = props;
    const selectedCategories = useMemo(() => splitComplianceCategories(value), [value]);
    return (React.createElement(FilterComponent, Object.assign({}, props, { tagProps: {
            clearValue: undefined,
            label: COPY_SPECIFIC.COMPLIANCE_CATEGORIES,
            value: selectedCategories
                .map((categoryId) => { var _a; return (_a = geLabelOverride(categoryId)) !== null && _a !== void 0 ? _a : ComplianceCategory[categoryId]; })
                .join(', ')
        } }),
        React.createElement(OptionFilter, { className: 'filter', getPopupContainer: getDirectParent, id: getFilterId(String(id)), maxTagCount: 'responsive', mode: 'multiple', onChange: (newSelection) => {
                const selection = transformSelection(newSelection, selectedCategories);
                onChange({
                    [id]: {
                        format,
                        value: selection ? aggregateComplianceCategories(selection) : undefined
                    }
                });
            }, options: options, placeholder: PLACEHOLDERS_COPY.FILTER_BY(label), showArrow: true, tagRender: (option) => React.createElement(ComplianceCategories, { categoryFlags: Number(option.value), direction: 'horizontal' }), value: selectedCategories })));
};
